import { mapMutations, mapState } from 'vuex';
export default {
  name  : 'Sidebar',
  props : {
    expandOnHover: {
      type    : Boolean,
      default : false
    },
    legacyLayout: {
      type    : Boolean,
      default : true
    }
  },
  data: () => ({
    activeList    : false,
    filterList    : '',
    listItem      : [],
    treeSelection : [],
    display       : 'list',
    backupItem    : []
  }),
  beforeMount() {
    this.createListItems();
  },
  computed: {
    ...mapState({
      features          : (state) => state._core.application.feature,
      itensOfNavigation : (state) => state._core.navigation.itensOfNavigation,
      configShowFilter  : (state) => state._core.application.configShowFilter,
      statusMini        : (state) => state._core.application.statusMini
    }),
    sidebarDrawer: {
      get() {
        return this.$store.state._core.application.sidebarDrawer;
      },
      set(val) {
        this.$store.commit('_core/application/SET_SIDEBAR_DRAWER', val);
      }
    },
    disableHeader() {
      return this.$route.query.disableHeader === 'true';
    }
  },
  watch: {
    filterList: function() {
      this.activeList = true;
      if (!this.filterList) {
        this.listItem = JSON.parse(JSON.stringify(this.backupItem));
      } else {
        this._handleBackupItems();
      }
    },
    features: {
      handler: function() {
        this.createListItems();
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations({
      setStatusMini: '_core/application/SET_STATUS_MINI'
    }),
    _setSubitems(feature, index) {
      if (this.$route.path.replace(/\/$/, '') === feature.webRoute ) {
        this.listItem[index] = { ...this.listItem[index], active: true };
      }
      this.listItem[index].subitens.push({ id: feature.id, title: feature.description, icon: (feature.icon) ? feature.icon : 'mdi-tools', link: feature.webRoute || feature.endpoint });
    },
    _setFeatures() {
      for (const feature of this.features) {
        if (feature.featureParentId !== null) {
          const index = this.listItem.findIndex(parent => parent.id === feature.featureParentId);
          if (index >= 0 && feature.menuVisibility) {
            if (!this.listItem[index].subitens) {
              this.listItem[index].subitens = [];
            }
            this._setSubitems(feature, index);
          }
        }
      }
    },
    _handleBackupItems() {
      this.listItem = [];
      this.backupItem.map(item => {
        if (this.stringComparation(item, this.filterList)) {
          this.listItem.push(item);
        } else {
          if (item.subitens) {
            const children = [];

            item.subitens.map(subitem => {
              if (this.stringComparation(subitem, this.filterList)) {
                children.push(subitem);
              }
            });

            if (children.length > 0) {
              const newItem = {
                icon     : item.icon,
                id       : item.id,
                link     : item.link,
                title    : item.title,
                subitens : children
              };

              this.listItem.push(newItem);
            }
          }
        }
      });
    },
    onTreeUpdate() {
      if (this.treeSelection.length > 0) {
        this.disabledButton = false;
      } else {
        this.disabledButton = true;
      }
    },
    redirectTo() {
      this.configStatusMenu();

      if (window.innerWidth < 1250) {
        this.$store.commit('_core/application/SET_SIDEBAR_DRAWER', false);
      }
    },
    configStatusMenu(tipo) {
      if (this.statusMini) {
        if (this.filter !== false) {
          this.showFilter = true;
        }
        this.setStatusMini(false);
      }
      if (tipo === 'link') {
        this.$emit('stateMenuMobile', false);
      }
    },
    stringComparation(item, filterList) {
      const titleItem = item.title.toUpperCase();
      const comparisonResult = titleItem.includes(`${filterList.toUpperCase()}`);

      return comparisonResult;
    },
    createListItems() {
      this.listItem = [...this.itensOfNavigation];
      const parents = this.features.filter(feature => feature.featureParentId === null);
      if (parents.length) {
        parents.map((parent) => {
          if (parent.menuVisibility) {
            this.listItem.push({ id: parent.id, title: parent.description, icon: (parent.icon) ? parent.icon : 'mdi-tools', link: parent.webRoute || parent.endpoint });
          }
        });
        this._setFeatures();
      }

      this.backupItem = JSON.parse(JSON.stringify(this.listItem));
    }
  }
};
